import { MaterialTypeSchema } from "../generated/prisma/zod";
import { PartTypeSchema } from "../generated/prisma/zod";
import { MaterialTypeType, PartTypeType } from "../types";

export const getMaterialTypesFromPartType = (partType: PartTypeType): MaterialTypeType[] => {
  switch (partType) {
    case PartTypeSchema.enum.SHEET:
      return [MaterialTypeSchema.enum.SHEET];
    case PartTypeSchema.enum.OTHER:
    case PartTypeSchema.enum.MACHINING:
      return Object.values(MaterialTypeSchema.enum);
    case PartTypeSchema.enum.ROUND_TUBE:
      return [MaterialTypeSchema.enum.ROUND_TUBE];
    case PartTypeSchema.enum.SQUARE_TUBE:
      return [MaterialTypeSchema.enum.SQUARE_TUBE];
    case PartTypeSchema.enum.RECTANGULAR_TUBE:
      return [MaterialTypeSchema.enum.RECTANGULAR_TUBE];
    case PartTypeSchema.enum.ROUND_BAR:
      return [MaterialTypeSchema.enum.ROUND_BAR];
    case PartTypeSchema.enum.SQUARE_BAR:
      return [MaterialTypeSchema.enum.SQUARE_BAR];
    case PartTypeSchema.enum.PROFILE:
      return [MaterialTypeSchema.enum.PROFILE];
    case PartTypeSchema.enum.CONSUMABLE:
    case PartTypeSchema.enum.ASSEMBLY:
      return [];
  }
};
